import SettingsDialog from "@/components/SettingsDialog";

export default function SettingsPage() {
  return <SettingsDialog mode="page" />;
}
